module.exports = __webpack_public_path__ + "976d8a7c2ede2b9c650771d8b3a60ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/user/images/icon.png
// module id = 758
// module chunks = 3